import React from 'react'
import { string, bool, object, any } from 'prop-types'

export const Select = ({ name, value, children, ...rest }) => (
  <option {...rest}
    children={null}
    name={name}
    value={value}>
    {children}
  </option>
)

Select.propTypes = {
  name: string,
  selected: bool,
  children: string,
  value: any
}

Select.contextTypes = {
  selectGroup: object
}



// WEBPACK FOOTER //
// ./src/components/ui/inputs/Select.js